/* eslint-disable */
// because legacy

import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'bootstrap/js/dropdown'
import 'bootstrap/js/tooltip'
import 'bootstrap/js/popover'
import 'bootstrap/js/collapse'

import '@bikemap/js/legacy/utils'
import '@bikemap/js/legacy/forms'

import initGlobal, { initCancelPageHeader } from '@bikemap/js/integrations/global'
import { CHECK_USERNAME_AVAILABLE_URL } from './settings'
import { InitPasswordField } from '@bikemap/js/integrations/authentication'
import { gettext, notifications } from './services'

initGlobal()
initCancelPageHeader()

const passwordField = new InitPasswordField(document.getElementById('reset-password'))
passwordField.render()

$(function() {
  "use strict"

  var $form = $("form#reset-password")

  var $submitButton = $form.find('[type="submit"]')

  $form.on("submit", function(ev) {
    $submitButton.prop("disabled", true).addClass("loading-spinner")
    ev.preventDefault()
    $.ajax({
      method: "POST",
      data: $form.serialize(),
      headers: { "X-CSRFToken": $.outdoorish.readCookie("csrftoken") },
      form: $form,
      busyElement: $submitButton,
      busyClass: "loading-spinner",
      keepBusy: true,
      complete: $.outdoorish.forms.handleAjaxFormErrors,
      success: data => {
        if (data.has_verification_error) {
          notifications.show({
            icon: 'i-info',
            title: gettext('Confirm your email address'),
            message: gettext('We just sent you another verification email. Please check your inbox and click the link to verify your email address!'),
            delay: 0,
          })
        }
      },
    })
  })

  var $usernameField = $("#id_username", $form)
  if ($usernameField.length > 0) {
    var usernameValidationRequest = null
    var usernameValidationTimeout = null

    var $previousUsername = null
    $usernameField.on("blur", function() {
      if ($usernameField.val() !== $previousUsername) {
        $previousUsername = $usernameField.val()

        var ret = $.outdoorish.forms.formFieldValidation(
          $usernameField,
          $form,
          $submitButton,
          CHECK_USERNAME_AVAILABLE_URL,
          usernameValidationRequest,
          usernameValidationTimeout
        )

        usernameValidationRequest = ret.ajaxRequest
        usernameValidationTimeout = ret.timeout
      }
    })
  }
})
